import { render, staticRenderFns } from "./InteractionsContainer.vue?vue&type=template&id=11438a58&scoped=true&"
import script from "./InteractionsContainer.vue?vue&type=script&lang=ts&"
export * from "./InteractionsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./InteractionsContainer.vue?vue&type=style&index=0&id=11438a58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11438a58",
  null
  
)

export default component.exports